<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4">
</a><h2 class="fmtitle"><a id="page_4"></a><a id="page_5">Dedication</a></h2><a id="page_5">
<p class="noindent1">To my dad, Gilberto Romero (1919–2009), for teaching me to read and to love books and to believe I could do anything I wanted to do. I did it, Daddy.</p>
<p class="noindent1">To my son, Paul Michael Anthony Bennett, for believing that having a mom who writes murder mysteries makes for a normal childhood.</p>
<p class="noindent1">To my husband and best friend, Paul, for always believing that it was a matter of “when”, not “if”.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?7f9e5550